import React from "react";

const BS5_Toast = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Toast Component</h2>
      <p>This is the BS5_Toast component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Toast;
